import { createSelector } from 'reselect';
import { highlightValueOnValueSetsHPSelector } from 'selectors/testTarget/offers/highlightValueOnValueSetsHP/highlightValueOnValueSetsHPSelector';

const activeSelector = createSelector(highlightValueOnValueSetsHPSelector, highlightValueOnValueSetsHP => !!highlightValueOnValueSetsHP.active);

export { activeSelector };
